import React from "react";
import NtarLoader from "../Loaders/NtarLoader";

const Loaders = () => {
  return <NtarLoader />;
};


export default Loaders;
